import * as React from 'react';
const SvgGraph = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.125 2.375a.75.75 0 0 1 .75.75v13h13a.75.75 0 0 1 0 1.5H3.125a.75.75 0 0 1-.75-.75V3.125a.75.75 0 0 1 .75-.75m14.148 1.364a.75.75 0 0 1 .238 1.034l-3.125 5a.75.75 0 0 1-1.236.052l-1.206-1.608-1.926 3.21a.75.75 0 0 1-1.243.065L7.547 9.855l-1.291 2.009a.75.75 0 0 1-1.262-.811L6.87 8.136A.75.75 0 0 1 8.1 8.092l1.206 1.607 1.926-3.21a.75.75 0 0 1 1.243-.064l1.219 1.625 2.545-4.073a.75.75 0 0 1 1.034-.238"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGraph;
